interface Config {
  basename: string;
  defaultPath: string;
  fontFamily: string;
  borderRadius: number;
  outlinedFilled: boolean;
  navType: string;
  presetColor: string;
  locale: string;
  rtlLayout: boolean;
  towerTheme: boolean;
}

const config: Config = {
  basename: '/',
  defaultPath: '/dashboard/default',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  outlinedFilled: true,
  navType: 'light',
  presetColor: 'default',
  locale: 'en',
  rtlLayout: false,
  towerTheme: false
};

export default config;
